import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "light";
}

const sizeStyles = {
  sm: "text-base",
  md: "text-xl",
  lg: "text-3xl",
};

const imgSizes = {
  sm: "h-6 w-6",
  md: "h-10 w-10",
  lg: "h-14 w-14",
};

const spacingStyles = {
  sm: "-space-x-1.5",
  md: "-space-x-2.5",
  lg: "-space-x-4",
};

export const Logo = ({ className, size = "lg", variant = "default" }: LogoProps) => {
  return (
    <a href="/" className={cn("flex items-center whitespace-nowrap", spacingStyles[size], className)}>
      <picture>
        <source srcSet="/sparklogo.webp" type="image/webp" />
        <img src="/sparklogo.png" alt="SparkJobs Logo" width={56} height={56} className={cn("object-contain shrink-0", imgSizes[size])} />
      </picture>
      <span className={cn("font-bold z-10 tracking-tight", sizeStyles[size])}>
        <span className="text-primary">SPARK</span>
        <span className={variant === "light" ? "text-white" : "text-foreground"}>JOBS</span>
      </span>
    </a>
  );
};
